'use strict'

/**
 * Project janux-vuejs-seed
 * Created by hielo on 2018-05-14
 */
import _ from 'lodash'

export function validationService () {
	const isPassword = /^[a-zA-Z0-9_-]{8,20}$/
	const isEmail = /^(([^<>()[\]\\.,:\s@"]+(\.[^<>()[\]\\.,:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

	return {
		/**
		 * Validates password strength and match against confirmation if required
		 * @param password The password
		 * @param confirm Optional password confirmation
		 * @returns true if everything is ok or throw error string code
		 */
		password: (password, confirm) => {
			// Check password confirmation
			if (!_.isNil(confirm)) {
				if (password !== confirm) {
					throw new Error('notMatch')
				}
			}
			// Check password strength
			if (!isPassword.test(password)) {
				throw new Error('strength')
			}
			return true
		},

		/**
		 * Validates if the email address meets the format or not
		 * @param email The email address
		 * @returns {boolean} indicating whether the email is valid or not
		 */
		email: (email) => {
			return (isEmail.test(email))
		},

		/**
		 *
		 * @param emails
		 * @return {boolean} return false only if any of the emails is invalid, otherwise return true
		 */
		everyEmailAddress: (emails) => {
			if (!_.isNil(emails) && emails.length > 0) {
				var validEmailCallback = (email) => {
					return this.email(email.address)
				}
				return _.every(emails, validEmailCallback)
			}
			return true
		},

		isEmail: isEmail
	}
}



// WEBPACK FOOTER //
// ./src/common/services/validation-service.js